import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ApiBasket, postAddRoommatesToBasket } from 'src/api/basketService';
import { RoommateData } from 'src/features/multi-occupancy/types';
import { syncBasket } from 'src/utils/sync-basket';

import { queryRetry } from '../query-retry';

export const usePostAddRoommatesToBasket = () =>
    useMutation<
        ApiBasket,
        AxiosError,
        { basketId: string; roommates: RoommateData[]; updatedAt: string }
    >({
        mutationFn: ({ basketId, roommates, updatedAt }) =>
            postAddRoommatesToBasket(basketId, roommates, updatedAt),
        retry: queryRetry,
        onSuccess: (basket) => {
            syncBasket(basket);
        },
    });
